<template>
  <div class="page sizeA4">
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <!-- imagens do topo -->
      <div class="row">
        <!-- <div class="d-flex justify-content-between mb-2"> -->
        <div class="col-md-10 mt-5">
          <div>
            <h1 class="text-dark fw-bolder mx-5 font-nome mt-5">
              {{ dados.nomeCompleto }}
            </h1>
          </div>
        </div>
        <div class="col-md-2 mt-5">
          <img
            class="img-curriculo"
            src="@/assets/images/extrato/unicampoLogo.jpg"
          />
        </div>
        <!-- </div> -->
      </div>

      <div class="d-flex justify-content-between">
        <div class="col-md-auto">
          <div class="faixa-lateral"></div>
        </div>
        <div class="col-md-10">
          <div class="mt-2">
            <div class="row">
              <div class="col-md-10" style="align-self: end">
                <div
                  class="col-md-9 badge badge-soft-secondary"
                  style="border-radius: 40px; width: 300px"
                >
                  <h4 class="fw-bold text-dark text-start mx-2 my-2">
                    DADOS PESSOAIS
                  </h4>
                </div>
              </div>
              <div class="col-md-2">
                <img
                  class="rounded-circle header-profile avatar-xl"
                  :src="fotoPerfil"
                  alt="Header Avatar"
                  v-if="fotoPerfil"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6 d-flex flex-column">
                <h3 class="mx-3 my-2">
                  <i class="mdi mdi-phone text-success"></i>
                  {{ dados.contato }}
                </h3>
                <h3 class="mx-3 my-2">
                  <i class="mdi mdi-account text-success"></i>
                  {{ dados.idade }} anos
                </h3>
                <h3 class="mx-3 my-2">
                  <i class="mdi mdi-map-marker text-success"></i>
                  {{ dados.endereco }}
                </h3>
                <h3 class="mx-3 my-2">
                  <i class="mdi mdi-email text-success"></i>
                  {{ dados.email }}
                </h3>
              </div>
              <div class="col-md-6 d-flex flex-column">
                <h3 class="mx-3 my-2">
                  Estado Civil - {{ dados.estadoCivil }}
                </h3>
                <h3 class="mx-3 my-2">Deficiência - {{ dados.deficiência }}</h3>
                <h3 class="mx-3 my-2">CNH - {{ dados.cnh }}</h3>
                <h3 class="mx-3 my-2">
                  Conselho Regional - {{ dados.tp_registro }}
                </h3>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <div class="row">
              <div
                class="badge badge-soft-secondary"
                style="border-radius: 40px; width: 300px"
              >
                <h4 class="fw-bold text-dark text-start mx-2 my-2">
                  DADOS ACADÊMICOS
                </h4>
              </div>
            </div>
            <div class="row mt-4">
              <div
                v-for="(curso, index) in dados.cursos"
                :key="index"
                class="col-md-12 d-flex flex-column"
              >
                <h3 class="mx-3 my-2">
                  {{ curso.NMCURSO }}
                </h3>
                <h3 class="mx-3 my-2">
                  {{ curso.NMINSTITUICAO }}
                </h3>
                <h3 class="mx-3 my-2">
                  {{ curso.FORMACAO }} | {{ curso.NRANOCONCLUSAO }} -
                  {{ curso.NRANOCONCLUSAO }} - {{ curso.STATUSFORMACAO }}
                </h3>
                <hr />
              </div>
            </div>
          </div>
          <!-- <div class="mt-3">
            <div class="row">
              <div
                class="badge badge-soft-secondary"
                style="border-radius: 40px; width: 300px"
              >
                <h4 class="fw-bold text-dark text-start mx-2 my-2">
                  EXPERIÊNCIA PROFISSIONAL
                </h4>
              </div>
            </div>
            <div class="row mt-4">
              <div
                v-for="(exp, index) in dados.expProfissional"
                :key="index"
                class="col-md-12 d-flex flex-column"
              >
                <h3 class="mx-3 my-2">
                  {{ capitalizeString(exp.nm_empresa) }}
                </h3>
                <h3 class="mx-3 my-2">
                  {{ capitalizeString(exp.ds_linha_negocio) }} |
                  {{ capitalizeString(exp.ds_perfil_profissional) }}
                </h3>
                <h3 class="mx-3 my-2 font-size-16">
                  {{ $tools.converteData(exp.dt_inicio) }} –
                  {{
                    exp.dt_final
                      ? $tools.converteData(exp.dt_final) + " - "
                      : ""
                  }}{{ tratarPeriodo(exp.dt_inicio, exp.dt_final) }}
                </h3>
                <h4 class="mx-3 my-2 font-size-16">
                  {{ exp.ds_atividade }}
                </h4>
                <div class="mx-3 my-2">
                  <h3 class="m-0">Ambientes de Atuação</h3>
                  <div class="d-flex">
                    <span class="col-auto font-size-16">
                      {{
                        montaNomesExp(
                          exp.ambientes_trabalho,
                          "ds_ambiente_trabalho"
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3 class="m-0">Região de Atuação</h3>
                  <div class="d-flex">
                    <span class="col-auto font-size-16">
                      {{ montaNomesExp(exp.regiao_trabalho, "nm_regiao") }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3 class="m-0">Cultura</h3>
                  <div class="d-flex">
                    <span class="col-auto font-size-16">
                      {{
                        montaNomesExp(
                          exp.cultura_trabalho,
                          "ds_item_financiado"
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3 class="m-0">Atividade</h3>
                  <div class="d-flex">
                    <span class="col-auto font-size-16">
                      {{
                        montaNomesExp(
                          exp.atividade_trabalho,
                          "ds_atividade_macro"
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3 class="m-0">Objetivo</h3>
                  <div class="d-flex">
                    <span class="col-auto font-size-16">
                      {{
                        montaNomesExp(
                          exp.objetivo_trabalho,
                          "ds_objetivo_negocio"
                        )
                      }}
                    </span>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div> -->

          <div class="mt-3">
            <div class="row">
              <div
                class="badge badge-soft-secondary"
                style="border-radius: 40px; width: 300px"
              >
                <h4 class="fw-bold text-dark text-start mx-2 my-2">
                  INTERESSES
                </h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12 d-flex flex-column">
                <div class="mx-3 my-2">
                  <h3>Área de Interesse</h3>
                  <div class="row">
                    <span class="col-auto font-size-16">
                      {{ pesInt }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3>Região de Interesse</h3>
                  <div class="row">
                    <span class="col-auto font-size-16">
                      {{ areasAtuacao }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3>Conhecimento e Habilidades</h3>
                  <div class="row">
                    <div class="col-auto font-size-16">
                      {{ pesHab }}
                    </div>
                  </div>
                </div>
                <div class="mx-3 my-2">
                  <h3>Ambiente de Interesse</h3>
                  <div class="row">
                    <div class="col-auto font-size-16">
                      {{ pesAmb }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="mt-3">
            <div class="row" v-if="dados.idioma.length > 0">
              <div
                class="badge badge-soft-secondary"
                style="border-radius: 40px; width: 300px"
              >
                <h4 class="fw-bold text-dark text-start mx-2 my-2">IDIOMA</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div
                v-for="(idioma, index) in dados.idioma"
                :key="index"
                class="col-md-12 d-flex flex-column"
              >
                <h3 class="mx-3 my-2 font-size-20">
                  {{ capitalizeString(idioma.DS_IDIOMA) }}
                </h3>
                <h3 class="mx-3 my-2 font-size-18">Nível de leitura</h3>
                <h4 class="mx-3 font-size-16">{{ idioma.NIVELLEITURA }}</h4>
                <h3 class="mx-3 my-2 font-size-18">Nivel de conversação</h3>
                <h4 class="mx-3 font-size-16">{{ idioma.NIVELFALA }}</h4>
                <h3 class="mx-3 my-2 font-size-18">Nivel de escrita</h3>
                <h4 class="mx-3 font-size-16">{{ idioma.NIVELESCRITA }}</h4>
                <hr />
              </div>
            </div>
          </div> -->
          <div class="row nao-imprimir">
            <div class="mt-1 d-flex justify-content-center">
              <b-button
                variant="primary"
                class="mt-1 me-1 w-lg btn-lg"
                @click="imprimir"
              >
                <i class="mdi mdi-fax"></i>
                Imprimir
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-md-auto">
          <div class="faixa-lateral"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  layout: "empty",
  data() {
    return {
      dados: {
        fotoPerfil: "",
        tp_registro: "",
        nomeCompleto: "",
        contato: "",
        idade: "",
        endereco: "",
        estadoCivil: "",
        dificiencia: "",
        cursos: [],
        // expProfissional: [],
        areaAtuacao: {
          gePesInt: [],
          geAreAtu: [],
          gePesHab: [],
          gePesAmb: [],
        },
        pesInt: "",
        areasAtuacao: "",
        pesHab: "",
        pesAmb: "",
        idioma: [],
      },
      estadoCivil: {
        C: "Casado(a)",
        D: "Divorciado(a)",
        R: "Relação Estável",
        S: "Separado(a)",
        T: "Solteiro(a)",
        V: "Viúvo(a)",
      },
      tipoCnh: {
        N: "Não tem",
        P: "Provisório",
        D: "Definitivo",
      },
      loading: true,
    };
  },
  created() {
    this.$store.commit("SET_MOSTRA_MENU", false);
    window.scrollTo(0, 0);
    this.cargaInicial();
  },
  methods: {
    async cargaInicial() {
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarDadosPessoais"),
        this.$http.get("api/cadastroCandidato/buscarRegistroProfissional"),
        this.$http.get("api/cadastroCandidato/buscarDeficiencia"),
        this.$http.get("api/cadastroCandidato/buscarContatos"),
        this.$http.get("api/cadastroCandidato/buscarEmails"),
        this.$http.get("api/cadastroCandidato/buscarEndereco"),
        this.$http.get("api/cadastroCandidato/buscarDadosAcademicos"),
        this.$http.get("api/cadastroCandidato/buscarExpCurriculo"),
        this.$http.get("api/cadastroCandidato/buscarAreaCurriculo"),
        this.$http.get("api/cadastroCandidato/buscarDadosIdiomas"),
        (() => {
          const token = this.$store.state.access_token;
          const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
          const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
          const headerMe = { headers: { Authorization: `Bearer ${token}` } };
          return this.$http.get(endpointMe, headerMe);
        })(),
      ]).then(
        ([
          respDadosPessoais,
          respDadosRegProfissional,
          respDeficiencia,
          respTel,
          respMai,
          respEndereco,
          respAcademico,
          respProfissao,
          respArea,
          respIdioma,
          respMe,
        ]) => {
          //NOME DO COOPERADO
          this.dados.nomeCompleto = respMe.data.nm_razao;
          if (respMe.data.foto) {
            this.fotoPerfil = this.$caminhoFotoPerfil + respMe.data.foto;
          }
          //CONTATO
          this.dados.contato = respTel.data.filter(
            (el) => el.st_principal == "S"
          );
          this.dados.contato =
            "(" +
            this.dados.contato[0].nr_ddd +
            ") " +
            this.dados.contato[0].nr_telefone;
          //IDADE
          this.dados.idade = this.$tools.calcularIdade(
            respDadosPessoais.data[0].DT_NASC
          );
          //ENDERECO
          this.dados.endereco = respEndereco.data[0].NMREGIAO;
          //EMAIL
          this.dados.email = respMai.data[0].ds_email;
          //ESTADO CIVIL
          var estadoCivil = respDadosPessoais.data[0].TP_EST_CIVIL;
          this.dados.estadoCivil = this.estadoCivil[estadoCivil];
          //DEFICIENCIA
          this.dados.deficiência =
            respDeficiencia.data.length > 0 ? "Possui" : "Não possui";
          //CNH
          var regProf = respDadosRegProfissional.data[0].REGISTRO;
          this.dados.tp_registro = regProf;
          var cnh = respDadosPessoais.data[0].TP_CNH;
          this.dados.cnh = this.tipoCnh[cnh];
          //Cursos
          this.dados.cursos = respAcademico.data;

          // Exp Profissional
          const profissoes = [];
          const ambientes = [
            "ambientes_trabalho",
            "regiao_trabalho",
            "cultura_trabalho",
            "objetivo_trabalho",
            "atividade_trabalho",
          ];

          respProfissao.data.forEach((elemento) => {
            const profissaoAuxiliar = elemento;
            ambientes.forEach((valor) => {
              profissaoAuxiliar[valor] = elemento[valor].filter(
                (filtro) =>
                  filtro.pivot.sq_experiencia === elemento.sq_experiencia
              );
            });
            profissoes.push(profissaoAuxiliar);
          });

          this.dados.expProfissional = profissoes;

          // Area Atuacao
          this.dados.areaAtuacao = respArea.data;
          this.pesInt = this.dados.areaAtuacao.gePesInt
            .map(
              (region) => `${this.capitalizeString(region.ds_area_interesse)}`
            )
            .join(" - ");
          this.areasAtuacao = this.dados.areaAtuacao.geAreAtu
            .map((region) => `${this.capitalizeString(region.nm_regiao)}`)
            .join(" - ");
          this.pesHab = this.dados.areaAtuacao.gePesHab
            .map((region) => `${this.capitalizeString(region.ds_habilidade)}`)
            .join("- ");
          this.pesAmb = this.dados.areaAtuacao.gePesAmb
            .map(
              (region) =>
                `${this.capitalizeString(region.ds_ambiente_trabalho)}`
            )
            .join(" - ");
          //IDIOMA
          this.dados.idioma = respIdioma.data;
          this.loading = false;
        }
      );
    },
    montaNomesExp(dados, nomeLabel) {
      var labelFormada = dados
        .map((region) => this.capitalizeString(region[nomeLabel]))
        .join(" - ");
      return labelFormada;
    },
    tratarPeriodo(dtInicio, dtFim) {
      if (!dtFim) {
        return "Trabalho atual";
      }
      var partesInicio = this.$tools.converteData(dtInicio).split("/");
      var partesFim = this.$tools.converteData(dtFim).split("/");
      var diaInicio = parseInt(partesInicio[0], 10);
      var mesInicio = parseInt(partesInicio[1], 10) - 1;
      var anoInicio = parseInt(partesInicio[2], 10);
      var diaFim = parseInt(partesFim[0], 10);
      var mesFim = parseInt(partesFim[1], 10) - 1;
      var anoFim = parseInt(partesFim[2], 10);
      var dataInicioObj = new Date(anoInicio, mesInicio, diaInicio);
      var dataFimObj = new Date(anoFim, mesFim, diaFim);
      var diffEmMilissegundos = Math.abs(dataFimObj - dataInicioObj);
      var diffEmDias = Math.floor(diffEmMilissegundos / (1000 * 60 * 60 * 24));
      var anos = Math.floor(diffEmDias / 365);
      var meses = Math.floor((diffEmDias % 365) / 30);
      var dias = diffEmDias % 30;
      var resultado = "";
      if (anos > 0) {
        resultado += anos + " ano";
        if (anos > 1) {
          resultado += "s";
        }
        resultado += " ";
      }
      if (meses > 0) {
        resultado += meses + " mês";
        if (meses > 1) {
          resultado += "es";
        }
        resultado += " ";
      }
      if (dias > 0) {
        resultado += dias + " dia";
        if (dias > 1) {
          resultado += "s";
        }
      }
      return resultado;
    },
    capitalizeString(str) {
      if(str){
        return str
          .split(" ")
          .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
          .join(" ");
      } else {
        return ""
      } 
    },
    imprimir() {
      window.print();
    },
  },
};
</script>

<style scoped>
.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
}
.sizeA4 {
  width: 28cm;
  height: 100%;
}

.font-nome {
  font-size: 40px;
}

.faixa-lateral {
  width: 25px; /* Largura da faixa */
  height: 100%; /* Altura da faixa (tamanho da folha A4) */
  background-color: #00923f; /* Cor da faixa */
}

.img-curriculo {
  width: 100%;
}

@media print {
  .nao-imprimir {
    display: none;
  }
  .font-nome {
    font-size: 20px;
  }

  .img-curriculo {
    width: 200px;
    float: right;
  }
}
</style>
